var Star1 = "/static/a2e5cb8f6a7c3cb6.png";

export { Star1 as default };
//# sourceMappingURL=star-1.png.js.map
